export function forEach(nodes,callback,scope){for(let i=0;i<nodes.length;i++){callback.call(scope,nodes[i],i)}}export default forEach;